import { create } from 'zustand';

type VariantPrice = {
  price: string;
  setPrice: (state: string) => void;
};

const useVariantPrice = create<VariantPrice>((set) => ({
  price: '',
  setPrice: (state: string) => set({ price: state }),
}));

export { useVariantPrice };
